var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.submit($event)
        }
      }
    },
    [
      _c(
        "b-form-group",
        { staticClass: "mt-4" },
        [
          _c("label", [
            _vm._v(
              _vm._s(
                _vm.$t("message.accountChangeEmailForm.label.currentEmail")
              )
            )
          ]),
          _vm._v(" "),
          _c("b-form-input", {
            staticClass: "rounded-0 text-muted",
            attrs: { value: _vm.currentEmail, disabled: "" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { staticClass: "mt-4" },
        [
          _c("label", [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("message.accountChangeEmailForm.label.email")) +
                "\n      "
            ),
            _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
          ]),
          _vm._v(" "),
          _c("b-form-input", {
            staticClass: "rounded-0",
            attrs: { state: _vm.$v.email.$error ? false : null },
            on: {
              changed: function($event) {
                _vm.$v.email.$touch()
              }
            },
            model: {
              value: _vm.email,
              callback: function($$v) {
                _vm.email = $$v
              },
              expression: "email"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          staticClass: "mt-4",
          attrs: { state: _vm.$v.emailConfirm.$error ? false : null }
        },
        [
          _c("label", [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t("message.accountChangeEmailForm.label.emailConfirm")
                ) +
                "\n      "
            ),
            _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
          ]),
          _vm._v(" "),
          _c("b-form-input", {
            staticClass: "rounded-0",
            attrs: { state: _vm.$v.emailConfirm.$error ? false : null },
            on: {
              changed: function($event) {
                _vm.$v.emailConfirm.$touch()
              }
            },
            model: {
              value: _vm.emailConfirm,
              callback: function($$v) {
                _vm.emailConfirm = $$v
              },
              expression: "emailConfirm"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-row",
        { staticClass: "mt-4" },
        [
          _c(
            "b-col",
            { staticClass: "text-right" },
            [
              _c("b-btn", { attrs: { variant: "primary", type: "submit" } }, [
                _c("span", { staticClass: "ti-save mr-2" }),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("message.accountChangeEmailForm.btn.save"))
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0625b895", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0625b895","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/AccountChangeEmailForm.vue
// module id = XLgd
// module chunks = 1